import * as React from 'react';

import {AiFeatureCard} from 'shells/ai-homepage/ai-feature-card/ai-feature-card';
import {FeatureCardGrid} from 'shells/grid-list/feature-card-grid';

import type {AiFeaturePeriod} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import type {AiFeature} from './types';

type Props = {
    features: AiFeature[];
    selectedUsageTab?: AiFeaturePeriod;
};

export function FeatureGrid(props: Props) {
    const renderCard = React.useCallback(
        (feature: AiFeature) => {
            return (
                <AiFeatureCard
                    title={feature.name}
                    description={feature.cardDescription}
                    thumbnailIllustration={feature.cardIllustration}
                    icon={feature.icon}
                    history={appHistory}
                    exploreLink={`/ai/home/${feature.pathSegment}${
                        props.selectedUsageTab
                            ? `?period=${props.selectedUsageTab.toLowerCase()}`
                            : ''
                    }`}
                />
            );
        },
        [props.selectedUsageTab]
    );

    const hasIllustration = React.useCallback((feature: AiFeature) => {
        return Boolean(feature.cardIllustration);
    }, []);

    const getKey = React.useCallback((feature: AiFeature) => {
        return feature.type;
    }, []);

    return (
        <FeatureCardGrid
            items={props.features}
            renderCard={renderCard}
            hasIllustration={hasIllustration}
            getKey={getKey}
        />
    );
}
